// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-virtual-scroll {
  display: block;
  flex: 1 1 auto;
  max-width: 100%;
  overflow: auto;
  position: relative;
}
:where(.vuetify-styles) .v-virtual-scroll__container {
  display: block;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VVirtualScroll/VVirtualScroll.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB","sourcesContent":[".v-virtual-scroll {\n  display: block;\n  flex: 1 1 auto;\n  max-width: 100%;\n  overflow: auto;\n  position: relative;\n}\n.v-virtual-scroll__container {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
